import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Subheader from './Subheader';
import StateStore from 'globalStates/Store';
import AppStore from 'context';

const Next = () => {
  const location = useLocation(); 

  useEffect(() => {
    
   
  }, [location]);

  return (
    <>
      {/* {loading && <LoaderChat opacity={0.01} color='black' />} */}
      <Outlet />
    </>
  );
};

const Layout = (props) => {
  const {onlOrgChange } = props;
  const [orgId, setOrgId] = useState(window.selectedOrganizationId);
  const onOrgChange = (orgId) => {
    setOrgId(orgId);
    onlOrgChange(orgId)
  }
  return (
    <AppStore>
      <StateStore>
        <section>
        <Header onOrgChange={onOrgChange} />
        <div className='main-gird'>
          {/* <Subheader /> */}
          <div className='bg-light'
          // style={{height:"auto",overflow:"hidden"}}
          >
            <Next />
          </div>
          </div>
        </section>
      </StateStore>
    </AppStore>
  );
};

export default Layout;
